// extracted by mini-css-extract-plugin
export default {"scrollWrapper":"HorizontalScroll_scrollWrapper__mrg8A","scroll":"HorizontalScroll_scroll__WQD-K"};